import { useEffect } from "react";

/**Hook para ocultar un contenedor al hacer clic fuera.
 * @param {ref} ref  referencia para indicar el nombre del contenedor a cerrar.
 */

export function useOnClickOutside(ref, handler) {
    useEffect(() => {
      const listener = event => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    }, [ref, handler]);
  }
